import { render, staticRenderFns } from "./center-home.vue?vue&type=template&id=35f541c8&scoped=true&"
import script from "./center-home.vue?vue&type=script&lang=js&"
export * from "./center-home.vue?vue&type=script&lang=js&"
import style0 from "./center-home.vue?vue&type=style&index=0&id=35f541c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f541c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f541c8')) {
      api.createRecord('35f541c8', component.options)
    } else {
      api.reload('35f541c8', component.options)
    }
    module.hot.accept("./center-home.vue?vue&type=template&id=35f541c8&scoped=true&", function () {
      api.rerender('35f541c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/home/components/center-home.vue"
export default component.exports